import React from 'react';
import PropTypes from 'prop-types'
import { translate } from 'react-i18next';
import { ThemeProvider } from 'styled-components';

import DataService from 'lib/DataService';

import {
	StyledInputWithLabel,
	StyledLabel,
	StyledSelect,
	theme,
} from 'lib/styles';

import { sortByAvailableAndFloor } from 'lib/utils';

import {
	Master,
	Default
} from '../Brochures/Brochure/styles'

import {
	SpaceLabel
} from './styles'

const Api = new DataService();

class CloneBrochure extends React.Component {
	constructor(props) {
		super(props)

		const { t } = props;

		this.state = {
			name: `${props.brochure.name} ${t('building/prompt/(Copy)')}`,
			suggestedName: true,
			type: 'normal',
			space: '',
			selectedSpaces: [],
			loading: false,
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.createClone === true) {
			this.createClone();
		}
	}

	getSuggestedName() {
		const { t, brochure, building } = this.props;

		if (this.state.space) {
			const space = building.spaces.find(space => space.slug === this.state.space);
			return `${brochure.name}, ${t('general/floor_abbr', { floor: space.floor })} ${space.area} m²`;
		}

		const spaces = this.getSelectedBuildingSpaces().filter(space => this.state.selectedSpaces.includes(space.slug));
		let name = brochure.name;

		spaces.forEach(space => {
			name += `, ${t('general/floor_abbr', { floor: space.floor })} ${space.area} m²`;
		});

		return name;
	}

	getSelectedBuildingSpaces() {
		const { building, brochure } = this.props;
		let spaces = [...building.spaces]		// Only show space that are assigned to a brochure page
			.filter(space => brochure.content.pages.some(page => page.options.space === space.slug));

		return spaces;
	}

	updateCloneBrochure() {
		this.props.setCanCloneBrochure(this.state.type !== 'default' || !!this.state.space);
	}

	spaceToggleHandler(slug) {
		let selectedSpaces = [ ...this.state.selectedSpaces ];

		const index = selectedSpaces.findIndex(spaceSlug => spaceSlug === slug);
		if (index !== -1) {
			selectedSpaces.splice(index, 1);
		} else {
			selectedSpaces.push(slug);
		}

		this.setState({ selectedSpaces }, () => {
			if (this.state.suggestedName) {
				this.setState({
					name: this.getSuggestedName(),
				})
			}
			this.updateCloneBrochure();
		});
	}

	typeToggleHandler(type) {
		const selectedSpaces = [];
		this.setState({ type, selectedSpaces }, () => {
			if (this.state.suggestedName) {
				this.setState({
					name: this.getSuggestedName(),
				})
			}
			this.updateCloneBrochure();
		});
	}

	brochureSpaceToggleHandler(space) {
		const selectedSpaces = [];
		if (this.getSelectedBuildingSpaces().find(item => item.slug === space)) {
			selectedSpaces.push(space);
		}
		this.setState({ space, selectedSpaces }, () => {
			if (this.state.suggestedName) {
				this.setState({
					name: this.getSuggestedName(),
				})
			}
			this.updateCloneBrochure();
		});
	}

	createClone() {
		this.setState({ loading: true });

		const { brochure } = this.props;
		const { name, selectedSpaces, type, space } = this.state;

		Api.cloneBrochureWithSpaces(brochure.id, name, selectedSpaces, type, space)
			.then(res => {
				this.props.addBrochureClone(res.result.brochure, selectedSpaces, space);
			})
	}

	render() {
		const { t, brochure, allowedBrochureTypes, allowedBrochureSpaces } = this.props;

		let brochureSpaces = (this.state.type === 'default' ? allowedBrochureSpaces : []);
		brochureSpaces.sort((a, b) => {
			if (a.floor < b.floor) {
				return -1
			}
			else if (a.floor === b.floor) {
				return a.area < b.area ? -1 : 1;
			}

			return 1;
		});
		brochureSpaces = brochureSpaces.map(space => {
			return {
				key: space.slug,
				value: space.slug,
				name: `${t('general/floor_abbr', { floor: space.floor })}, ${space.area} m², ${space.name}${space.isFree ? ', ' + t('building/spaces/Available') : ''}`
			}
		});
		brochureSpaces.splice(0, 0, { key: '-', value: '', name: t('controls/text/content/choose') });
		const spaces = this.state.type !== 'default' ? this.getSelectedBuildingSpaces() : [];

		spaces.sort(sortByAvailableAndFloor);

		const types = allowedBrochureTypes.map(type => ({ value: type, name: t('brochure/Type/' + type), selected: this.state.type === type }));

		return (
			<ThemeProvider theme={{ ...theme }}>
				<div>
					<h2>
						{t('building/Brochures/Copy')}
						{' '}
						{
							brochure.type === 'master' &&
							<Master>Master</Master>
						}
						{
							brochure.type === 'default' &&
							<Default>Default</Default>
						}
						{brochure.name}
					</h2>

					<StyledInputWithLabel
						label={t('building/prompt/Brochure name')}
						type="text"
						value={this.state.name}
						onChange={e => this.setState({ name: e.target.value, suggestedName: false })}
						disabled={this.state.loading}
					/>

					<StyledLabel
						htmlFor="brochure-type">{t('building/prompt/Brochure type')}</StyledLabel>
					<StyledSelect
						value={this.state.type}
						id="brochure-type"
						addEmptyOption={false}
						onChange={e => this.typeToggleHandler(e.target.value)}
						options={types}
						style={{ width: '100%', margin: '8px 0 30px' }}></StyledSelect>

					{
						this.state.type === 'default' && <>
							<StyledLabel
								htmlFor="brochure-space">{t('building/prompt/Brochure space')}</StyledLabel>
							<StyledSelect
								value={this.state.space}
								id="brochure-space"
								addEmptyOption={false}
								onChange={e => this.brochureSpaceToggleHandler(e.target.value)}
								options={brochureSpaces}
								style={{ width: '100%', margin: '8px 0 30px' }}></StyledSelect>
						</>
					}

					{
						spaces.length > 0 &&
						<h4>{t('building/Brochures/Select spaces')}</h4>
					}

					{
						spaces.map(space => {
							return (
								<SpaceLabel key={space.slug} htmlFor={`toggle-${space.slug}`}>
									<input
										type={'checkbox'}
										id={`toggle-${space.slug}`}
										value={space.slug}
										checked={this.state.selectedSpaces.includes(space.slug)}
										onChange={() => this.spaceToggleHandler(space.slug)}
										disabled={this.state.loading}
									/>
									{space.name}, {space.area} m², {t('general/floor_abbr', { floor: space.floor })}
									{' '}
									{
										space.isFree &&
										<span>{t('building/spaces/Available')}</span>
									}
								</SpaceLabel>
							)
						})
					}
				</div>
			</ThemeProvider>
		);
	}
}

CloneBrochure.propTypes = {
	building: PropTypes.object,
	brochure: PropTypes.object,
	allowedBrochureTypes: PropTypes.array,
	createClone: PropTypes.bool,
	addBrochureClone: PropTypes.func,
	setCanCloneBrochure: PropTypes.func,
	t: PropTypes.func,
}

export default translate('translations')(CloneBrochure);
